import { createRouter, createWebHashHistory } from 'vue-router';
import Dashboard from './components/Dashboard.vue';

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
    },
    {
        path: '/cliente',
        name: 'cliente',
        component: () => import('./pages/Clientes.vue')
    },
    {
        path: '/cliente/crear',
        name: 'clientecreate',
        component: () => import('./pages/clientes/create.vue')
    },
    {
        path: '/cliente/editar/:id',
        name: 'clienteedit',
        component: () => import('./pages/clientes/edit.vue')
    },
    {
        path: '/proveedor',
        name: 'proveedor',
        component: () => import('./pages/Proveedores.vue')
    },
    {
        path: '/insumos',
        name: 'insumos',
        component: () => import('./pages/Insumos.vue')
    },
    {
        path: '/insumos/:id',
        name: 'insumosview',
        component: () => import('./pages/Insumos.vue')
    },
    {
        path: '/trazabilidad',
        name: 'Trazabilidad',
        component: () => import('./pages/Trazabilidad.vue')
    },
    {
        path: '/desplegados',
        name: 'Desplegados',
        component: () => import('./pages/Desplegados.vue')
    },
    {
        path: '/solicitud-insumos',
        name: 'solicitud-insumos',
        component: () => import('./pages/SolicitudInsumos.vue')
    },    
    {
        path: '/orden-compra',
        name: 'orden-compra',
        component: () => import('./pages/OrdenCompra.vue')
    },
    {
        path: '/reporte-insumos',
        name: 'reporte-insumos',
        component: () => import('./pages/ReporteInsumos.vue')
    },
    {
        path: '/ManoDeObra',
        name: 'ManoDeObra',
        component: () => import('./pages/ManoDeObra.vue')
    },
    {
        path: '/productos',
        name: 'productos',
        component: () => import('./pages/Productos.vue')
    },
    {
        path: '/productos/crear',
        name: 'productoscreate',
        component: () => import('./pages/productos/create.vue')
    },
    {
        path: '/productos/editar/:id',
        name: 'productosedit',
        component: () => import('./pages/productos/edit.vue')
    },
    {
        path: '/presupuestos',
        name: 'presupuestos',
        component: () => import('./pages/Presupuestos.vue')
    },
    {
        path: '/presupuestos/crear',
        name: 'presupuestoscreate',
        component: () => import('./pages/presupuestos/create.vue')
    },
    {
        path: '/presupuestos/editar/:id',
        name: 'presupuestosedit',
        component: () => import('./pages/presupuestos/edit.vue')
    },
    {
        path: '/presupuesto-ver/:id',
        name: 'presupuestover',
        component: () => import('./pages/presupuestos/preview.vue')
    },
    {
        path: '/maquinaria',
        name: 'maquinaria',
        component: () => import('./pages/Maquinaria.vue')
    },
    {
        path: '/logistica',
        name: 'logistica',
        component: () => import('./pages/Logistica.vue')
    },
    {
        path: '/material',
        name: 'material',
        component: () => import('./pages/Materiales.vue')
    },
    {
        path: '/unidades',
        name: 'unidades',
        component: () => import('./pages/Unidades.vue')
    },
    {
        path: '/usuario',
        name: 'usuario',
        component: () => import('./pages/Users.vue')
    },
    {
        path: '/produccion',
        name: 'produccion',
        component: () => import('./pages/production/list.vue')
    },
    {
        path: '/produccion/:id',
        name: 'ordenprod',
        component: () => import('./pages/production/show.vue')
    },
    {
        path: '/produccion-ver/:id',
        name: 'ordenprodview',
        component: () => import('./pages/production/preview.vue')
    },
    {
        path: '/orden/:id',
        name: 'oti',
        component: () => import('./pages/production/oti_show.vue')
    },
    {
        path: '/produccion/:id/addorder',
        name: 'CreateOti',
        component: () => import('./pages/production/oti_create.vue')
    },
    {
        path: '/produccion/crear',
        name: 'CreateProduccion',
        component: () => import('./pages/production/create.vue')
    },
    {
        path: '/produccion/editar/:id',
        name: 'EditProduccion',
        component: () => import('./pages/production/edit.vue')
    },
    {
        path: '/estadisticas/:of',
        name: 'Stats',
        component: () => import('./pages/Stats.vue')
    },
    {
        path: '/mantenimiento',
        name: 'Mantenimiento',
        component: () => import('./pages/Mantenimiento.vue')
    },
    {
        path: '/configuraciones',
        name: 'Configuraciones',
        component: () => import('./pages/Configuraciones.vue')
    },
    {
        path: '/tipos-de-cliente',
        name: 'tipo-clientes',
        component: () => import('./pages/TiposCliente.vue')
    },
    {
        path: '/condiciones-de-venta',
        name: 'condiciones-venta',
        component: () => import('./pages/CondicionesVenta.vue')
    },
    {
        path: '/zonas',
        name: 'zonas',
        component: () => import('./pages/Zonas.vue')
    },
    {
        path: '/sectores',
        name: 'sectores',
        component: () => import('./pages/Sectores.vue')
    },
    {
        path: '/transportes',
        name: 'transportes',
        component: () => import('./pages/Transportes.vue')
    },
    {
        path: '/planos',
        name: 'planos',
        component: () => import('./pages/Planos.vue')
    },
    {
        path: '/almacenes',
        name: 'almacenes',
        component: () => import('./pages/Almacenes.vue')
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
